var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dialogue", {
        attrs: {
          title: "Add Job Order to Trip " + _vm.tripid,
          button_names: ["Add"],
          show: _vm.add_dialogue,
          autoClose: false,
          html: _vm.add_html,
          autocompleteId: 58
        },
        on: { dialogue: _vm.addDialogue, cancel: _vm.addDialogueCancel }
      }),
      _vm._v(" "),
      _vm.tripid == null
        ? _c("layout-1", {
            staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
            attrs: {
              table_name: "Trips",
              id: _vm.pageid1,
              searchbar: true,
              navbar: true,
              nav_items: ["Add Trip"],
              nav_item_perms: ["134"],
              button_perm: "134",
              button_name: "Select",
              term: _vm.term
            },
            on: { select: _vm.selectTrip }
          })
        : _c(
            "div",
            [
              _c("layout-1", {
                key: _vm.updateKey,
                staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
                attrs: {
                  table_name: "Trip " + _vm.tripid,
                  id: _vm.pageid2,
                  navbar: true,
                  nav_items: ["Add Job Order", "Edit Trip"],
                  nav_item_perms: ["134", "134"],
                  term: _vm.tripid
                },
                on: { button: _vm.selectButton }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a820cf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a820cf4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Trips.vue
// module id = 626
// module chunks = 0